<template>
  <el-drawer title="添加收信人" :visible.sync="visibility" direction="rtl" size="975px" append-to-body>
    <section class="w-full h-full pt-4 box-border overflow-hidden" v-loading="loading">
      <el-tabs class="full-tabs" value="group" type="card" v-if="isShowSelect">
        <el-tab-pane label="从群组选择" name="group">
          <add-recipient-group ref="groupRef" @confirm-add="addConfirm" />
        </el-tab-pane>
      </el-tabs>
      <add-recipient-step @refresh="getSamples" v-else />
    </section>
  </el-drawer>
</template>

<script>
import { getSampleGroup } from '@/api/wenjuan/sample_new'
import AddRecipientStep from './AddRecipientStep'
import AddRecipientGroup from './AddRecipientGroup'

export default {
  name: 'SmsRecipientDrawer',
  components: {
    AddRecipientStep,
    AddRecipientGroup
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
    // 暂时无法回填选择框
    // checks: {
    //   type: Array,
    //   default: () => []
    // },
  },
  model: {
    prop: 'visible',
    event: 'visibility-change'
  },
  data() {
    return {
      isShowSelect: false,
      loading: false
    }
  },
  computed: {
    visibility: {
      get() {
        return this.visible
      },
      set(bool) {
        this.$emit('visibility-change', bool)
      }
    }
  },
  watch: {
    visibility() {
      this.setRowSelection()
    },
    isShowSelect() {
      this.setRowSelection()
    }
  },
  mounted() {
    this.getSamples()
  },
  methods: {
    getSamples() {
      const params = {
        current: 1,
        size: 1,
      }
      this.loading = true
      getSampleGroup({}, params)
        .then(res => {
          const records = res || [];
          this.isShowSelect = records.length > 0;
        })
        .catch(() => {
          this.$message.error('无法获取样本信息')
        })
        .finally(() => {
          this.loading = false
        })
    },
    addConfirm(data = {}) {
      this.visibility = false
      this.$emit('confirm-add', data)
    },
    setRowSelection() {
      if (this.visibility && this.isShowSelect) {
        this.$nextTick(() => {
          if (this.$refs.groupRef) {
            this.$refs.groupRef.setRowSelection()
          }
        })
      }
    }
  }
}
</script>
